export default "__VITE_ASSET__5cba54a8__"